/* eslint-disable max-len */
// THIS FILE IS USED TO GENERATE CHUNKS PER PAGE
// SO THAT SPA'S CAN LOAD THE NECESSARY CHUNKS PER PAGE
/* eslint-disable no-nested-ternary */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined';

export const getServerPages = async () => {
  const Components = {};
  if (ssr) {
    Components.productReviews = (await import('./pages/ProductReviewsContainer')).ProductReviewsContainer;
    Components.productQuestions = (await import('./pages/ProductQandAContainer')).ProductQandAContainer;
    Components.home = (await import('./pages/Home')).Home;
    Components.thankYou = (await import('./pages/ThankYouContainer')).ThankYouContainer;
  }
  return Components;
};

export const getRoutes = (currentRouteName, currentRouteComponent, serverPages) => ({
  productReviews: {
    name: 'ProductReviewsContainer',
    componentName: 'ProductReviewsContainer',
    chunk: () => import('./pages/ProductReviewsContainer'),
    get component() {
      return ssr
        ? serverPages.productReviews
        : currentRouteName === 'ProductReviewsContainer'
          ? currentRouteComponent
          : generateAsyncRoute(
            () => this.chunk().then((pageModule) => ({ default: pageModule.ProductReviewsContainer })));
    },
    path: '/:context?/p/reviews/:slug?/:itemId/:page?',
    channel: null,
    varnish: true
  },

  productQuestions: {
    name: 'ProductQandAContainer',
    componentName: 'ProductQandAContainer',
    chunk: () => import('./pages/ProductQandAContainer'),
    get component() {
      return ssr
        ? serverPages.productQuestions
        : currentRouteName === 'ProductQandAContainer'
          ? currentRouteComponent
          : generateAsyncRoute(
            () => this.chunk().then((pageModule) => ({ default: pageModule.ProductQandAContainer })));
    },
    path: '/:context?/p/questions/:slug?/:itemId/:page?',
    channel: null,
    varnish: true
  },

  home: {
    name: 'Home',
    componentName: 'Home',
    chunk: () => import('./pages/Home'),
    get component() {
      return ssr
        ? serverPages.home
        : currentRouteName === 'Home'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.Home })));
    },
    path: '/:context?/',
    channel: null,
    varnish: true
  },

  thankYou: {
    name: 'ThankYouContainer',
    componentName: 'ThankYouContainer',
    chunk: () => import('./pages/ThankYouContainer'),
    get component() {
      return ssr
        ? serverPages.thankYou
        : currentRouteName === 'ThankYouContainer'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.ThankYouContainer })));
    },
    path: '/:context?/l/reviews/confirmation',
    channel: null,
    varnish: true
  },
});

export const getRouteChunk = async (currentRouteName) => {
  const routes = getRoutes();
  const routeKey = Object.keys(routes).filter((key) => routes[key].name === currentRouteName)[0];
  const route = routes[routeKey];
  const componentModule = await route.chunk();

  return componentModule[route.componentName];
};
